import React from "react";
import "./B2Page.css";

const B2CourseDetails = () => {
  return (
    <div className="b2DetailsContainer">
      <h3>
        It is the upper intermediate level. The course begins with an
        introduction to the easier part of German B2 Grammar.
      </h3>
      <ul>
        <li>This course Consists of B2.1 and B2.2</li>
        <li>It covers Large Variety of Topics</li>
        <li>
          One can learn more about the German culture through idioms and quotes.
        </li>
        <li>Discussing Difficult Topics and Work-Related Issues</li>
        <li>Understanding the Formal Texts in Journals and Newspapers</li>
        <li>
          Discussions on Themes like Politics, Economy, Technology, People and
          Relationships, Environment and several other Topics.
        </li>
        <li>
          You will Get the Command of Language after successfully completing it.
        </li>
        <li>
          Learn to state Personal Views and Opinions in both Formal and Informal
          environment.
        </li>
        <li>Learn to Discuss, Analyze and Interpret different Texts</li>
        <li>
          Explaining Yourself on a wide range of Topics in a detailed Manner
        </li>
        <li>
          After completion, you will be able to lead a fluent and spontaneous
          Conversation with a Native Speaker
        </li>
        <li>Understanding specialized Discussions</li>
        <li>
          Certificate serves as a proof in Public, Professional and Educational
          Situations
        </li>
      </ul>
    </div>
  );
};

export default B2CourseDetails;
